<nav class="navbar navbar-expand-lg bg-body-tertiary shadow-nav py-1">
    <div class="container-fluid">
        <a class="navbar-brand text-primary" (click)="toggleSidebar()">
            <i class="fas fa-bars"></i>
        </a>
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item dropdown">
                <a class="nav-link d-flex align-items-center" nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click" nzPlacement="bottomRight">
                    <nz-avatar [nzText]="dataUser.username.slice(0, 2).toUpperCase()" style="color: white; background-color:var(--primary-color);"></nz-avatar>
                    <div class="ms-2">
                        <p class="mb-0 fw-bold" style="font-size: 11px; line-height: 15px;">{{ dataUser.username }}</p>
                    </div>
                    <i class="fas fa-chevron-down ms-3"></i>
                </a>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu>
                      <li nz-menu-item><button (click)="cerrarSesion()" class="menu-button"><i class="fas fa-sign-out-alt ms-1"></i> Cerrar sesión</button></li>
                    </ul>
                </nz-dropdown-menu>
            </li>
        </ul>
    </div>
</nav>